import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeContractNameCommand extends BaseCommand {
  CommandName = "ChangeContractName";
  Command: { Value: string };
  constructor(sessionId: string, operationId: string, value: string) {
    super(sessionId, operationId);
    this.Command = { Value: value };
  }
}
